module.exports = __webpack_public_path__ + "media/images/logo/vzvz-608f5dbe614f4be7a825afec5b1931fe.svg";